__turbopack_context__.v({
  "close": "style-module-scss-module__X2DuTW__close",
  "container": "style-module-scss-module__X2DuTW__container",
  "error": "style-module-scss-module__X2DuTW__error",
  "safari": "style-module-scss-module__X2DuTW__safari",
  "snackbar": "style-module-scss-module__X2DuTW__snackbar",
});
